import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

export const sectionStyle = (isVideoEnabled: boolean, isSharingScreen: boolean) =>
  makeStyles(() => ({
    mainSection: {
      height: isVideoEnabled || isSharingScreen ? "calc(100vh - 269px)" : "calc(100vh - 140px)",
      margin: "0px 6px 0px 6px",
      background: "transparent",
      padding: "0 0 12px",
      marginTop: "-48px",
      borderRadius: 8,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      "& > div": {
        height: "100%",
      },
      "& div[role=tablist]": {
        "& div": {
          display: "none",
        },
        "& div[role=tabpanel]": {
          borderBottom: "none",
        },
      },
    },
    tabClass: {
      overflow: "auto",
      height:
        isVideoEnabled || isSharingScreen
          ? "calc(100vh - 320px) !important"
          : "calc(100vh - 192px) !important",
      borderRadius: "0 0 8px 8px",
      "&::-webkit-scrollbar": {
        width: "6px",
        borderRadius: "8px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#EDF5FB",
        borderRadius: "8px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#465869",
        borderRadius: "8px",
      },
    },
    removePaddingTop: {
      paddingTop: "8px !important",
    },
  }));

export const profileStyle = (isVideoEnabled: boolean, isSharingScreen: boolean) =>
  makeStyles(() => ({
    profileSection: {
      background: "#FFF",
      borderRadius: "8px",
      height: isVideoEnabled || isSharingScreen ? "calc(100% - 12px)" : "calc(100% - 9px)",
      display: "flex",
      flexFlow: "column",
      margin: "0px 6px 0px 6px",
      padding: "12px",
      marginTop: "12px",
    },
  }));

const styles = makeStyles(() => {
  return {
    tabHeaderClass: {
      width: "100%",
      backgroundColor: "#fff",
      "&.MuiTab-root.Mui-selected": {
        backgroundColor: `${colors.blue50} !important`,
      },
      "&:hover": {
        backgroundColor: `${colors.blue50} !important`,
      },
    },
    iconsContainer: {
      display: "flex",
    },
    iconTabClass: {
      marginRight: "0px !important",
      backgroundColor: "#fff",
      "&:hover": {
        backgroundColor: `${colors.blue50} !important`,
      },
    },
    lighterBorder: {
      border: "1px solid #E4E7EC",
      maxWidth: "22vw",
    },
  };
});

export default styles;
